import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import getWeekDays from 'owa-datetime-utils/lib/getWeekDays';
import { DisplayDate } from 'owa-datetime';

/**
 * Get an array with the days of the first week of the current date range.
 */
export default function getDaysInFirstWeek(store: CalendarSurfaceStore): DisplayDate[] {
    return getWeekDays(store.dateRange.start, store.userOptions.weekStartDay);
}
